import type { ReactNode } from 'react';
import { usePortalStatus } from '@/hooks/usePortalStatus';
import PortalMaintenancePage from '@/pages/portal/PortalMaintenancePage';

interface PortalGateProps {
  children: ReactNode;
}

/**
 * PortalGate wraps every /portal/* route.
 *
 * Behaviour:
 * - While the status is loading: render children immediately (never block the
 *   UI on a slow poll — the backend will hard-503 if the portal is truly down).
 * - When `enabled === false`: replace the entire route with the maintenance page.
 * - When `enabled === true`: render children normally.
 */
export function PortalGate({ children }: PortalGateProps) {
  const { enabled, isLoading } = usePortalStatus();

  // Fail-open during loading: don't block the UI
  if (isLoading) {
    return <>{children}</>;
  }

  if (!enabled) {
    return <PortalMaintenancePage />;
  }

  return <>{children}</>;
}
